export enum ChangeType {
  FeatureChanges = 'FeatureChanges',
  SystemUpdate = 'SystemUpdate',
  ScreenshotsAvailable = 'ScreenshotsAvailable',
}
